let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4Kqi2")).then(() => parcelRequire('gO8uB'));